import { api } from "./client";
import {
  waitForScanWith,
  type FileScanStatus,
  type WaitForScanOptions,
} from "./file-scan-wait";

/**
 * Taramanın genel kapısı: `GET /files/{id}/status` (`files.file.read`). Bekleme döngüsü `file-scan-wait.ts`'te, çünkü o
 * anahtarı taşımayan ekran (şoförün teslim kanıtı) aynı döngüyü kendi ucuyla kullanıyor ve bu ucu ağacına almamalı
 * (`check:screen-access` uçları içe aktarma ağacından okuyor).
 */
export {
  isSettled,
  refusal,
  waitForScanWith,
  type FileScanReader,
  type FileScanStatus,
  type WaitForScanOptions,
} from "./file-scan-wait";

export const fileScanApi = {
  status(fileId: string, signal?: AbortSignal): Promise<FileScanStatus> {
    return api.get<FileScanStatus>(
      `/files/${encodeURIComponent(fileId)}/status`,
      signal ? { signal } : {},
    );
  },
};

/** Dosya kullanılabilir olana kadar bekler; genel uçla. Yeni bir yükleme akışı kendi döngüsünü yazmaz. */
export function waitForScan(fileId: string, options: WaitForScanOptions = {}): Promise<FileScanStatus> {
  return waitForScanWith((id, signal) => fileScanApi.status(id, signal), fileId, options);
}
